import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
// import withData from '@bd/bdcore-data';
// import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
// import PageWrapper from '../../components/PageWrapper';
// import InsideHeader from '../../components/InsideHeader';
// import ContentBanner from '../../components/ContentBanner';
// import LivingMenu from '../../components/menus/Living';
import { colors, typography } from '../../styles';

const styles = css`
  padding-top: 30px;
  @media(min-width: 992px) {
    padding-top: 60px;
  }
  .PageSection_title {
    font-family: ${typography.SansSerif};
    color: ${colors.color1};
    font-weight: 200;
    text-transform: uppercase;
    font-size: 30px;
    margin-bottom: 20px;
    letter-spacing: 1px;
    margin-bottom: 15px;
    padding: 0 20px;
    @media (min-width: 992px) {
      font-size: 35px;
      padding: 0 0 10px 5px;
    }
    @media (min-width: 1200px) {
      font-size: 40px;
    }
  }

  .CalendarCards_wrapper {
    padding: 20px;
    width: calc(100% - 40px);
    margin: 0 auto 50px;
    background: ${colors.white};
    box-shadow: 0 10px 15px 0 rgba(0,0,0,0.05);
    transition: all .3s ease;
    border: 1px solid ${colors.color4Darkest};
    background-color: ${colors.color4Dark};
    @media(min-width: 768px) {
      margin: 0 auto 50px;
      max-width: calc(48% - 20px);
    }
    @media(min-width: 992px) {
      max-width: calc(32% - 20px);
    }
  }
  .CalendarCards_title {
    color: ${colors.color1Dark};
    font-size: 26px;
    line-height: 30px;
    border-bottom: 2px solid ${colors.color2};
  }
  .CalendarCards_body {
    p, ul {
      padding: 0 0 0 20px;
      margin: 0;
      li {
        padding: 7px 0;
      }
    }
    p, ul, li {
      font-size: 20px;
      line-height: 30px;
    }
  }
`;


function CalendarCards({ page }) {
  return (
    <div className={styles}>
      {
        page.map((content, c) => (
          <div className="CalendarCards_pageSection container" key={c.toString()}>
            {
              get(content, 'section_title') &&
              <div className="row mx-0">
                <h3 className="PageSection_title">{get(content, 'section_title')}</h3>
              </div>
            }
            <div className="row mx-0">
              {
                get(content, 'event_calendar', []).map(month => (
                  <div className="CalendarCards_wrapper" key={month._id}>
                    {
                      get(month, 'calendar_month', []).map(item => (
                        <div className="CalendarCards_content" key={get(item, 'month_name')}>
                          <div className="CalendarCards_heading">
                            <h6 className="CalendarCards_title">{get(item, 'month_name')}</h6>
                          </div>
                          <div className="CalendarCards_bodyWrapper">
                            <div
                              className="CalendarCards_body"
                              dangerouslySetInnerHTML={SanitizeHtml(get(item, 'events'))}
                            />
                          </div>
                        </div>
                      ))
                    }
                  </div>
                ))
              }
            </div>
          </div>
        ))
      }
    </div>
  );
}

CalendarCards.propTypes = {
  page: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default (CalendarCards);



// WEBPACK FOOTER //
// ./src/pages/PortAransas/CalendarCards.js